module.exports = __webpack_public_path__ + "img/PKR.b1c7f65b.svg";